'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DialogTitle;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DialogTitleStyled = require('./styles/DialogTitleStyled');

var _DialogTitleTextStyled = require('./styles/DialogTitleTextStyled');

var _DialogSubtitleTextStyled = require('./styles/DialogSubtitleTextStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  haveCloseButton: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  subtitle: _propTypes2.default.string,
  paddingSize: _propTypes2.default.oneOf(['none', 'default'])
};

var defaultProps = {
  haveCloseButton: false,
  title: '',
  subtitle: '',
  paddingSize: 'default'
};

function DialogTitle(props) {
  var subtitle = props.subtitle ? _react2.default.createElement(
    _DialogSubtitleTextStyled.DialogSubtitleTextStyled,
    null,
    props.subtitle
  ) : null;

  return _react2.default.createElement(
    _DialogTitleStyled.DialogTitleStyled,
    {
      paddingSize: props.paddingSize,
      haveCloseButton: props.haveCloseButton
    },
    _react2.default.createElement(
      _DialogTitleTextStyled.DialogTitleTextStyled,
      null,
      props.title
    ),
    subtitle
  );
}

DialogTitle.propTypes = propTypes;
DialogTitle.defaultProps = defaultProps;
DialogTitle.displayName = 'DialogTitle';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-dialog/dist/DialogHeading/DialogTitle/DialogTitle.js
// module id = 658
// module chunks = 0